/** A development's verdict, as a badge. */
const STYLES = {
  alive: 'border-white/40 text-white bg-white/5',
  dead: 'border-[#4a2a2a] text-[#b07070]',
  open: 'border-[#3a413a] text-[#888888]',
  retracted: 'border-[#333333] text-[#666666] line-through',
  reference: 'border-[#2e3a44] text-[#8fa3b3]',
};

export default function Verdict({ verdict, className = '' }) {
  return (
    <span
      className={`inline-block px-2 py-0.5 text-[10px] font-mono lowercase rounded border tracking-wide ${STYLES[verdict] || STYLES.open} ${className}`}
      title={`verdict: ${verdict}`}
    >
      {verdict}
    </span>
  );
}

export function formatDay(iso) {
  if (!iso) return '';
  const d = new Date(`${iso.slice(0, 10)}T00:00:00`);
  return d.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }).toLowerCase();
}
